import routerDashboard from "@/routing/routerDashboard";
import { addNoIndexTag } from "@/core/services/headModificator";
import { insertGoogleScripts } from "@/apps/whiteLabelWebsite/whiteLabel/core/infrastructure/service/gtmService";
import { setCustomLayoutByOrganization } from "@/core/services/layout.service";
import Dashboard from "@/Dashboard.vue";
import initSharedVueApp from "@/apps/shared/main";
import { useCartStore } from "@/core/store/cart/cartStore";

export default async () => {
  addNoIndexTag();
  if (process.env.VUE_APP_GTM_ID_DASHBOARD) {
    insertGoogleScripts(process.env.VUE_APP_GTM_ID_DASHBOARD);
  }

  setCustomLayoutByOrganization(true);

  await useCartStore().initCart(true);

  initSharedVueApp(routerDashboard, Dashboard);
};
